import Layout from "../../../../src/components/layout";
import Seo from "../../../../src/components/seo";
import * as React from 'react';
export default {
  Layout,
  Seo,
  React
};